/**
 * Schemas for the `faqs.*` tRPC procedure.
 *
 * Filtered server-side by `locale = ctx.locale` — there is NO English
 * fallback for missing locales. Editorial policy: every FAQ must be
 * authored in all 3 supported locales OR explicitly skipped.
 */

import { z } from "zod";

export const faqItemSchema = z.object({
  id: z.number().int(),
  question: z.string(),
  answer: z.string(),
  position: z.number().int(),
});
export type FaqItem = z.infer<typeof faqItemSchema>;

export const faqsListInputSchema = z.object({
  /** Outbreak-scoped FAQ; omit for global. */
  slug: z.string().min(1).max(100).optional(),
});
export type FaqsListInput = z.infer<typeof faqsListInputSchema>;

export const faqsListOutputSchema = z.array(faqItemSchema);
